<ng-container [formGroup]="form">
  <ion-item>
    <ion-label class="ion-text-wrap">
      {{
        UtilService.findObj(
          list,
          "questionTranslationLanguageId",
          sharedDataService.getLanguageIdForForm()
        ).questionTranslationTextLabel
      }}
    </ion-label>

    <ion-checkbox
      mode="md"
      slot="start"
      [formControlName]="inputName"
      [value]="true"
      [id]="questionId"
    >
    </ion-checkbox>
  </ion-item>
</ng-container>
